import { render, staticRenderFns } from "./topUnitCard.vue?vue&type=template&id=a8b10f96&"
import script from "./topUnitCard.vue?vue&type=script&lang=js&"
export * from "./topUnitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports